import { EntityTypes } from 'models/entity';

// The context key the API hard-branches on into the TaskAgent's conversation loop (see
// CopilotController.GeneralKnowledgeCompletion). The agent decides from the task itself whether it
// gathers evidence (the task proves one-time audit criteria) or explains (any other task).
export const TaskAssistantContextKey = 'TaskAssistant';

// Why the pane was opened. It decides the welcome text and the opening question: the server picks the agent's mode
// from the task, so an evidence task explains itself with the evidence rules in force. 'context' also sends
// TaskAssistantContextSkill with every question, which gives the agent its context tools and rubric. 'assessment' is
// an assessment task (PLAN-075): the server runs the agent's assessment mode, which answers the task's form. 'check' sends
// TaskAssistantCheckSkill when it is run, which judges the task's stored evidence without the model loop. 'audit' is no
// turn of the agent: it starts the AI evidence audit of the assessment task's item (PLAN-CTI-090) and tells the result.
export type TaskAssistantAction = 'evidence' | 'explain' | 'context' | 'assessment' | 'check' | 'audit';

// The skill the context action names on every turn: the agent proposes the task's relevant context, which the
// task modal applies to its unsaved task (a ContextProposal block).
export const TaskAssistantContextSkill = 'task-context-suggest';

// The skill of "Check evidence" (a preview feature, copilot.audit): the server judges the task's stored evidence with
// the inspection engine and answers with the evidence status table.
export const TaskAssistantCheckSkill = 'task-evidence-check';

// The criterion path that opened an evidence task: the entity whose criteria the task proves and the
// criterion keys it was created or selected for. The pane does not send it (the server resolves the
// task's bindings itself); the host uses it to know the task came from the criterion path.
export interface EvidenceTaskContext {
  entityType: EntityTypes;
  entityId: number;
  criterionKeys: string[];
}
